import { styled } from '@mui/system';
import { Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const NotificationContainer = styled('div')(({ theme }) => ({
  borderRadius: '4px',
  boxShadow: theme.shadows[5],
  padding: theme.spacing(1),
  display: 'flex',
  justifyContent: 'space-between',
  width: '320px',
  height: '76px',
  backgroundColor: theme.palette.background.secondarySelected,
}));

export const NotificationContent = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(1),
  gap: theme.spacing(1),
  flex: 1,
  minWidth: 0,
}));

export const NotificationText = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
}));

export const NotificationHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: '100%',
}));

export const NotificationBody = styled(Typography)(({ theme }) => ({
  color: theme.colors.gray,
  fontSize: '12px',
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  lineHeight: '1.2',
}));

export const NotificationCloseIcon = styled(CloseIcon)(({ theme }) => ({
  color: theme.palette.text.primary,
  flexShrink: 0,
}));
